// Everything shown in the home "Work" section, grouped by service category.
//
// projects: case studies. `featured` ones are large cards (with
//   title + type); the others are small tiles. All framed 4:3, linked.
// media: loose shots and clips at their natural aspect ratio, no labels or
//   links. Normally added from /admin (Firestore); entries here use the
//   same shape: { category, src, alt, video?, large? }.
import { CATEGORIES } from "../../config";

import uidaptCover from "../../pages/UIDapt/uidapt-cover.mp4";
import swatchCover from "../../pages/Swatch/swatch-cover.png";
import tuniscoveryVid from "../../pages/Tuniscovery/assets/tuniscovery-cover.webm";
import unidebVid from "../../pages/UnidebNotes/assets/unidebnotes-cover.webm";
// MENASYP video is in public folder
const menasypVid = "/menasyp_mobile_optimized.mp4";

export const projects = [
  { title: "BMW Group", category: CATEGORIES.ai, type: "Forward-Deployed Engineering", photo: "/bmw/cover.jpg", path: "/bmw", featured: true },
  { title: "UIDapt", category: CATEGORIES.ai, type: "Thesis, Mobile app", video: uidaptCover, path: "/uidapt", featured: true },
  { title: "Swatch MCP", category: CATEGORIES.ai, photo: swatchCover, path: "/swatch-mcp" },
  { title: "Tuniscovery", category: CATEGORIES.ux, type: "App, UX/UI", video: tuniscoveryVid, path: "/tuniscovery", featured: true },
  { title: "UNIDEB Notes", category: CATEGORIES.ux, video: unidebVid, path: "/unidebnotes" },
  { title: "IEEE R8 MENA SYP 2025", category: CATEGORIES.brand, type: "Branding", video: menasypVid, path: "/menasyp25", featured: true },
];

// Static media (usually empty: add shots from /admin instead)
export const media = [];
